"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PackageCard = _interopRequireDefault(require("../PackageCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IntegrationCard(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_PackageCard.default, {
    data: data,
    showIcon: true,
    showVerification: true,
    showPlatforms: true,
    showChannel: true
  });
}
var _default = exports.default = IntegrationCard;